import React, { useEffect, useMemo, useState } from "react"
import { Container } from "reactstrap"
import { formatAmount } from "helpers/common"
import TableContainer from "components/Common/TableContainer"
import Breadcrumb from "components/Common/Breadcrumb"
import DefaultAvatar from "components/CommonForBoth/TopbarDropdown/DefaultAvatar"
import { useParams } from "react-router-dom"
import { useLazyGetCommissionInvestorWpQuery } from "store/api/reports/reports"
import { useLazyGetWealthPartnerQuery } from "store/api/wealth-partner/wealth-partners.api"

const defaultFilters = {
    search: "",
    page: 1,
    pageSize: 20,
}

const InvestorCommissionReportsWP = () => {
    const [trigger] = useLazyGetCommissionInvestorWpQuery()
    const [filters, setFilters] = useState(defaultFilters)
    const [data, setData] = useState([])
    const { id } = useParams();
    const [wpName, setWpName] = useState("")
    document.title = `Commision Report | Prachay`

    const getList = async () => {
        try {
            const { data, success } = await trigger({ id }).unwrap()
            if (success) {
                setData(data?.data)
                setWpName(data?.wp?.name)
            }
        } catch (error) { }
    }

    useEffect(() => {
        getList()
    }, [])


    const columns = useMemo(() => {
        const headers = [
            {
                header: "Name of Investor",
                accessorKey: "name",
                enableColumnFilter: false,
                enableSorting: false,
                cell: ({ row }) => (
                    <DefaultAvatar
                        avatar_url={`${process.env.REACT_APP_FILE_URL}/avatar/investor/${row?.original?.avatar}`}
                        email={row?.original?.email}
                        name={row?.original?.name}
                    />
                ),
            },
            {
                header: "Invested Amount (₹)",
                accessorKey: "total_amount",
                enableColumnFilter: false,
                enableSorting: false,
                cell: ({ row }) => <>₹ {formatAmount(row.original.total_amount)}</>,
            },
            {
                header: "Commission Earned",
                accessorKey: "commission",
                enableColumnFilter: false,
                enableSorting: false,
                cell: ({ row }) => <>₹ {formatAmount(row.original.commission)}</>,
            },
        ]

        return headers
    }, [])

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumb title={`Commission Report ( ${wpName} )`} />

                    <div className="quarterterly-tds-table-wrapper">
                        <TableContainer
                            filters={filters}
                            setFilters={setFilters}
                            count={data.length}
                            columns={columns}
                            data={data}
                            buttonName={"Invite"}
                            isGlobalFilter={true}
                            isCustomPageSize={false}
                            isPagination={false}
                            pagination="pagination"
                            paginationWrapper="dataTables_paginate paging_simple_numbers"
                            tableClass="table-bordered   table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                        />
                    </div>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default InvestorCommissionReportsWP
